import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Optimalcloud() {
  return (
    <section className="optimal_cloud speech_optimal_voice p-100 tekrevol_dark_bg">
      <Container>
        <Row>
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>Gain Optimal Voice Recognition Performance with TekRevol</h2>
            <p>
              Maximize the accuracy, efficiency, and security of your voice
              recognition systems with TekRevol's cutting-edge solutions. Our
              expertise in voice technology ensures seamless integration and
              robust performance for your digital infrastructure.
            </p>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <div className="optimal_cloud_box">
              <div className="optimal_item">
                <div className="optimal_item_content">
                  <h2>80%</h2>
                  <p>
                    Reduction in Speech
                    <br /> Recognition Errors
                  </p>
                </div>
              </div>
              <div className="optimal_item">
                <div className="optimal_item_content">
                  <h2>60%</h2>
                  <p>
                    Improvement in Processing
                    <br /> Speed and Responsiveness
                  </p>
                </div>
              </div>
              <div className="optimal_item">
                <div className="optimal_item_content">
                  <h2>70%</h2>
                  <p>
                    Enhancement in User
                    <br /> Experience and Accessibility
                  </p>
                </div>
              </div>
              <div className="optimal_item">
                <div className="optimal_item_content">
                  <h2>100%</h2>
                  <p>
                    Compliance with Data Privacy
                    <br /> and Security Standards
                  </p>
                </div>
              </div>
              <div className="optimal_item">
                <div className="optimal_item_content">
                  <h2>99.9%</h2>
                  <p>Service Uptime for Uninterrupted Operations</p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Optimalcloud;
